/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown>, price: NonNullable<unknown> }} Creditpackamount2Inputs */

const en_creditpackamount2 = /** @type {(inputs: Creditpackamount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits · ${i?.price}`)
};

const de_creditpackamount2 = /** @type {(inputs: Creditpackamount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} Credits · ${i?.price}`)
};

/**
* | output |
* | --- |
* | "{credits} credits · {price}" |
*
* @param {Creditpackamount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpackamount2 = /** @type {((inputs: Creditpackamount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpackamount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpackamount2(inputs)
	return de_creditpackamount2(inputs)
});
export { creditpackamount2 as "creditPackAmount" }